// src/components/sections/HomeHero.jsx
import React, { useRef } from 'react'
import { motion as Motion, useInView } from 'framer-motion'
import Button from '../common/Button.jsx'
import TechOrb from "../common/TechOrb/TechOrb.jsx";
import './HomeHero.scss'
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice.js';

// Local BlurIn (adapted from your v1 BlurIn)
function BlurIn({ as: Component = 'div', children, className = '', duration = 2 }) {
    const ref = React.useRef(null)
    const isInView = useInView(ref, { once: false })

    return (
        <Motion.div
            ref={ref}
            initial={{ filter: 'blur(20px)', opacity: 0 }}
            animate={isInView ? { filter: 'blur(0px)', opacity: 1 } : {}}
            transition={{ duration }}
            className={className}
        >
            <Component>{children}</Component>
        </Motion.div>
    )
}

export default function HomeHero({ sectionData }) {
    const sectionRef = useRef(null)
    const dispatch = useDispatch();

    const handleOpenContactModal = () => {
        dispatch(openModal({
            modalType: 'contact',
            modalProps: {}
        }));
    };

    // SKELETON (same functionality, nicer wrapper)
    if (!sectionData) {
        return (
            <div className="premium-home">
                <section
                    className="premium-hero-home relative min-h-screen"
                    ref={sectionRef}
                >
                    <div className="hero-content">
                        <div className="hero-inner-content">
                            <div className="h-12 bg-black-200 rounded w-3/4 mx-auto mb-6"></div>
                            <div className="h-6 bg-black-200 rounded w-5/6 mx-auto mb-8"></div>
                            <div className="h-12 bg-black-200 rounded w-48 mx-auto"></div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    const { iconUrl, heading, subheading, buttonText, buttonLink } = sectionData

    return (
        <div className="premium-home">
            <section
                className="premium-hero-home"
                ref={sectionRef}
            >
                {/* TechOrb - will be positioned by CSS */}
                <TechOrb className="tech-orb-container" />

                <div className="hero-content">
                    <div className="hero-inner-content">
                        <BlurIn as="h1" className="hero-title">
                            {heading?.toUpperCase() || ''}
                        </BlurIn>

                        <BlurIn as="p" className="hero-subtitle">
                            {subheading ||
                                ""}
                        </BlurIn>

                        <Motion.div
                            className="hero-button-container"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            whileHover={{
                                scale: 1.02,
                                boxShadow: '0 15px 35px rgba(0,0,0,0.3)',
                            }}
                        >
                            <Button
                                size="large"
                                className="cta-button schedule-btn"
                                onClick={() => {
                                    handleOpenContactModal();
                                }}
                            >
                                {buttonText || 'Schedule a Free Consultation'}
                            </Button>
                        </Motion.div>
                    </div>
                </div>
            </section>
        </div>
    )
}